/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'

const triggersSlice = createSlice({
  name: 'triggers',
  initialState: {
    data: {},
  } as any,
  reducers: {
    setTriggersData: (
      state,
      { payload: { triggersData } }: PayloadAction<{triggersData: any}>,
    ) => {
      state.data = { ...triggersData }
    },
    removeTrigger: (
      state,
      { payload: { triggerId } }: PayloadAction<{ triggerId: string }>,
    ) => {
      // Create a new object without the property corresponding to `triggerId`
      const { [triggerId]: removedTrigger, ...remainingTriggers } = state.data;
      state.data = remainingTriggers;
    },
    removeMultipleTriggers: (
      state,
      { payload: { triggerIds } }: PayloadAction<{ triggerIds: string[] }>,
    ) => {
      state.data = Object.keys(state.data)
        .filter((key) => !triggerIds.includes(key))
        .reduce((acc, key) => {
          acc[key] = state.data[key];
          return acc;
        }, {} as typeof state.data);
    },
    extraReducers: (builder) => {
      builder.addCase(PURGE, (state: any) => {
        state = triggersSlice.getInitialState()
      })
    },
  },
});

export const {
  setTriggersData,
  removeTrigger,
  removeMultipleTriggers,
} = triggersSlice.actions;

export default triggersSlice.reducer;
